<template>
  <transition leave-active-class="duration-300">
    <div v-show="isOpen">
      <div class="fixed inset-0 flex z-40">
        <transition
          enter-active-class="transition-opacity ease-linear duration-300"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition-opacity ease-linear duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            class="fixed inset-0"
            @click="close()"
            v-show="isOpen"
          >
            <div class="absolute inset-0 bg-gray-600 opacity-75" />
          </div>
        </transition>

        <transition
          enter-active-class="transition ease-in-out duration-300 transform"
          enter-class="-translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transition ease-in-out duration-300 transform"
          leave-class="translate-x-0"
          leave-to-class="-translate-x-full"
        >
          <div
            v-show="isOpen"
            class="relative flex flex-col bg-indigo-600 w-max overflow-y-scroll"
          >
            <div
              class="absolute top-10 right-4 z-50"
              v-if="!hasMenuNeopassForm && !hasMenuCartographieCollective && !hasMenuTemplates && !hasMenuCartographieIndividuelle && !hasMenuCurriculumVitae"
            >
              <div
                aria-label="Fermer menu"
                @click="close()"
                class="cursor-pointer p-4 rounded-full bg-pink-600"
              >
                <icon 
                  name="chevron-left"
                  class="text-white w-3 h-3"
                />
              </div>
            </div>
            <menu-desktop
              @changePage="close()"
              v-if="!$isGuest()"
            />
          </div>
        </transition>
        <transition
          enter-active-class="transition ease-in-out duration-300 transform"
          enter-class="-translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transition ease-in-out duration-300 transform"
          leave-class="translate-x-0"
          leave-to-class="-translate-x-full"
        >
          <menu-formulaire 
            v-show="isOpen && hasMenuNeopassForm" 
            @changePage="close()"
          />
        </transition>
        <transition
          enter-active-class="transition ease-in-out duration-300 transform"
          enter-class="-translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transition ease-in-out duration-300 transform"
          leave-class="translate-x-0"
          leave-to-class="-translate-x-full"
        >
          <menu-cartographie-collective 
            v-show="isOpen && hasMenuCartographieCollective" 
            @changePage="close()"
          />
        </transition>
        <transition
          enter-active-class="transition ease-in-out duration-300 transform"
          enter-class="-translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transition ease-in-out duration-300 transform"
          leave-class="translate-x-0"
          leave-to-class="-translate-x-full"
        >
          <menu-page-template
            v-show="isOpen && hasMenuTemplates" 
            @changePage="close()"
          />
        </transition>
        <transition
          enter-active-class="transition ease-in-out duration-300 transform"
          enter-class="-translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transition ease-in-out duration-300 transform"
          leave-class="translate-x-0"
          leave-to-class="-translate-x-full"
        >
          <menu-cartographie-individuelle
            v-show="isOpen && hasMenuCartographieIndividuelle" 
            @changePage="close()"
          />
        </transition>
        <transition
          enter-active-class="transition ease-in-out duration-300 transform"
          enter-class="-translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transition ease-in-out duration-300 transform"
          leave-class="translate-x-0"
          leave-to-class="-translate-x-full"
        >
          <menu-cv-formulaire
            v-show="isOpen && hasMenuCurriculumVitae" 
            @changePage="close()"
          />
        </transition>
        <div class="relative">
          <div
            class="absolute top-10 right-5 z-50"
            v-if="isOpen && (hasMenuNeopassForm || hasMenuCartographieCollective || hasMenuTemplates || hasMenuCartographieIndividuelle || hasMenuCartographieIndividuelle || hasMenuCurriculumVitae)"
          >
            <div
              aria-label="Fermer menu"
              @click="close()"
              class="cursor-pointer p-4 rounded-full bg-pink-600"
            >
              <icon 
                name="chevron-left"
                class="text-white w-3 h-3"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from './Icon';
import MenuLinkMobile from './MenuLinkMobile';
import BetaTag from './BetaTag.vue';
import MenuDesktop from './MenuDesktop.vue';
import MenuFormulaire from './MenuFormulaire.vue';
import MenuCartographieCollective from './MenuCartographieCollective.vue';
import MenuPageTemplate from './MenuPageTemplate.vue';
import MenuCartographieIndividuelle from './MenuCartographieIndividuelle.vue';
import MenuCvFormulaire from './MenuCvFormulaire.vue';

export default {
  name: 'MenuMobile',
  props: {
    isOpen: Boolean,
    hasMenuNeopassForm: Boolean,
    hasMenuCartographieCollective: Boolean,
    hasMenuTemplates: Boolean,
    hasMenuCartographieIndividuelle: Boolean,
    hasMenuCurriculumVitae: Boolean
  },

  components: {
    MenuLinkMobile,
    Icon,
    BetaTag,
    MenuDesktop,
    MenuFormulaire,
    MenuCartographieCollective,
    MenuPageTemplate,
    MenuCartographieIndividuelle,
    MenuCvFormulaire,
  },

  data() {
    return {
      staticPages: [
        {
          libelle: 'Aide',
          link: '/aide/contact',
          icon: 'info',
          name: 'HelpContact',
        }
      ]
    };
  },

  methods: {
    close() {
      this.$emit('close', false);
    }
  },

  computed: {
    ...mapGetters({
      isFullMenu: 'listMenus/isFullMenu',
      listPages: 'listMenus/listPages',
    }),

    currentPage() {
      return this.$route.path;
    },
  }
};
</script>
